// @flow
import React from 'react';
import { connect } from 'react-redux';
import Modal from '@localytics/loc-components/lib/Modal';
import NodePicker from './NodePicker';
import { deselectNode as deselectNodeAction } from '../actions/tree';

export const STANDARD_ADD_NODE_SIZE = 48;

export type AddNodeProps = {
  parentName: string,
  next: string,
  nextKey: string,
  height: number,
  rx: number,
  ry: number,
  selected: boolean,
  dispatch: Function,
  editable: boolean
};

const AddNodePlusButton = () => (
  <use xlinkHref="#common-plus" x="11" y="11" height="25" width="26" />
);

const AddNode = (props: AddNodeProps) => {
  const { selected } = props;
  return (
    <g>
      <Modal
        show={selected}
        onHide={() => props.dispatch(deselectNodeAction())}
        className="NodePicker__Modal"
      >
        <NodePicker {...props} />
      </Modal>
      <AddNodePlusButton />
    </g>
  );
};

const ConnectedAddNode = connect()(AddNode);

export { ConnectedAddNode as AddNode };



// WEBPACK FOOTER //
// ./src/components/AddNode.jsx